import { useSelector } from 'react-redux';
import { RootState } from '../../logic/features/reducer.root-index';

// this just allows me to infer the RootState instead of having to write it out constantly
export const useRootSelector = <TResponse>(
    selector: (state: RootState) => TResponse,
    equalityFn?: ((left: TResponse, right: TResponse) => boolean) | undefined
) => useSelector(selector, equalityFn);
